import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";

import { DeletedTtPage, TtPage } from "@/CodegenTypes";
import { times } from "lodash";

import { TT_MODE_NAMES } from "@/constants/index";
import { queries } from "@/apollo";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTDeletedPageDetailsModal',
  props: {
    value: { type: Boolean },
    pageId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  pageId?: TtPage["id"];
};





const { result: deletedTtPageResult } = useQuery<{
  deletedTtPage: DeletedTtPage;
}>(
  queries.deletedTtPage,
  {
    id: computed(() => props.pageId),
  },
  {
    enabled: computed(() => !!props.pageId),
  }
);

const deletedTtPage = computed(() => deletedTtPageResult.value?.deletedTtPage ?? null);
const startIndex = ref(0);
const PER_PAGE = 40;
const clickCounter = ref(0);

const rowsPerTable = computed(() => PER_PAGE / 2);
const totalEntriesCount = computed(() => deletedTtPage.value?.entries.length);
const entriesInPage = computed(() => {
  const endIndex = startIndex.value + PER_PAGE;
  return deletedTtPage.value?.entries.slice(startIndex.value, endIndex);
});

const entriesInFirstTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(0, rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "" });
  });
  return [...dataRows, ...padRows];
});

const entriesInSecondTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "" });
  });
  return [...dataRows, ...padRows];
});

function toggleModal(val: boolean) {
  emit("input", val);
}

function convertModeValToName(val: string) {
  return (TT_MODE_NAMES as Record<string, string>)[val];
}

watch(
  () => props.value,
  () => {
    startIndex.value = 0;
  }
);

return { __sfc: true,props, emit, deletedTtPageResult, deletedTtPage, startIndex, PER_PAGE, clickCounter, rowsPerTable, totalEntriesCount, entriesInPage, entriesInFirstTable, entriesInSecondTable, toggleModal, convertModeValToName }
}

})